/**@flow */

import React from "react";
import { localize } from "redux-i18n";
import { View, StatItem } from "@components";
import { transformSecondsInHours } from "@transformers/date";
import type { EmploymentSummaryType } from "@modules/employee/types";

type OwnProps = $Exact<{
  summary: EmploymentSummaryType,
  customItems?: Array<Object>,
  defaultBorder?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class EmploymentSummary extends React.Component<Props> {
  get defaultItems() {
    return [
      {
        title: this.props.t("ACTIVE_ROLES"),
        value: this.props.summary.totalNumberOfActivePositions,
      },
      {
        title: this.props.t("WEEKLY_CONTRACTED_HOURS"),
        value: transformSecondsInHours(this.props.summary.totalWeeklyContractedHoursInSeconds),
      },
      {
        title: this.props.t("WORKING_DAYS_YEAR"),
        value: this.props.summary.totalWorkingDaysPerYear,
      },
      {
        title: this.props.t("TOTAL_FTE"),
        value: this.props.summary.totalFte,
      },
      {
        title: this.props.t("TOTAL_SALARY"),
        value: <div>&pound;{this.props.summary.totalSalary}</div>,
      },
    ];
  }

  get statItems() {
    return this.props.customItems || this.defaultItems;
  }

  render() {
    return (
      // this.props.defaultBorder
      <View direction="row" gap={6}>
        {this.statItems.map(props => (
          <StatItem key={props.title} {...props} />
        ))}
      </View>
    );
  }
}

export default localize()(EmploymentSummary);
